import { render, staticRenderFns } from "./shipmentData.vue?vue&type=template&id=29673c5a&scoped=true&"
import script from "./shipmentData.vue?vue&type=script&lang=js&"
export * from "./shipmentData.vue?vue&type=script&lang=js&"
import style0 from "./shipmentData.vue?vue&type=style&index=0&id=29673c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29673c5a",
  null
  
)

export default component.exports